import { Box, Skeleton } from '@mui/material'
import React from 'react'

const shimmerSx = { backgroundColor: 'rgba(34, 93, 153, 0.07)' }

function LoadingSkeleton() {
  return (
    <Box sx={{ p: 3, backgroundColor: '#eef4fb', minHeight: '100vh' }}>

      <Box
        sx={{
          backgroundColor: '#fff',
          borderRadius: '16px',
          boxShadow: '0 4px 16px rgba(12,61,110,0.07)',
          overflow: 'hidden',
        }}
      >
        <Box sx={{ padding: '20px 22px', display: 'flex', alignItems: 'center', gap: '14px' }}>
          <Skeleton
            animation="wave"
            variant="circular"
            height={44}
            width={44}
            sx={shimmerSx}
          />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Skeleton animation="wave" variant="rounded" height={18} width={250} sx={{ borderRadius: '6px', ...shimmerSx }} />
            <Skeleton animation="wave" variant="rounded" height={14} width={180} sx={{ borderRadius: '5px', ...shimmerSx }} />
          </Box>
        </Box>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '12px', padding: '0 20px 20px' }}>
          <Skeleton animation="wave" variant="rounded" height={56} sx={{ flex: '1 1 240px', borderRadius: '12px', ...shimmerSx }} />
          <Skeleton animation="wave" variant="rounded" height={56} sx={{ flex: '1 1 240px', borderRadius: '12px', ...shimmerSx }} />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '18px', mt: 3 }}>
        <Skeleton animation="wave" variant="rounded" height={350} sx={{ flex: '1 1 420px', borderRadius: '18px', ...shimmerSx }} />
        <Skeleton animation="wave" variant="rounded" height={350} sx={{ flex: '1 1 420px', borderRadius: '18px', ...shimmerSx }} />
      </Box>

    </Box>
  )
}

export default LoadingSkeleton